export { default } from '@shikijs/langs/mdc'
